export default function TabHeader({
  activeTab,
  setActiveTab,
  disabled = false,
}) {
  const tabs = [
    { id: "work", label: "Work History" },
    { id: "passport", label: "Passport Details" },
    { id: "travel", label: "Travel History" },
  ];

  return (
    <div className="border-b border-gray-200 px-8 pt-6">
      <div className="flex gap-8">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              disabled={disabled}
              onClick={() => {
                if (!disabled) setActiveTab(tab.id);
              }}
              className={`pb-2 text-sm transition-colors
                ${
                  isActive
                    ? "text-[#9D0385] font-bold border-b-2 border-[#9D0385]"
                    : "text-[#222222] hover:text-gray-900"
                }
                ${
                  disabled
                    ? "cursor-not-allowed opacity-50 hover:text-[#222222]"
                    : ""
                }
              `}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
